module.exports = __webpack_public_path__ + "static/media/ruhtinas-blue-bg-gold-300x140.260de55c.png";